import { useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import DashboardNavbar from "./DashboardNavbar";
import DashboardSidebar from "./DashboardSidebar";
// MOBILE-SHELL (3 Nov): phone bottom bar Today / Clients / Messages / More
import CoachBottomNav from "src/pages/CoachWorkspace/CoachBottomNav";

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 65;

const RootStyle = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
});

const MainStyle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  paddingTop: APP_BAR_MOBILE,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("lg")]: {
    paddingTop: APP_BAR_DESKTOP,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  if (!localStorage.getItem("token")) {
    return <Navigate to="/login"> </Navigate>;
  } else if (!localStorage.getItem("user_data")) {
    localStorage.clear();
    return <Navigate to="/login"> </Navigate>;
  }

  return (
    <RootStyle>
      <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
      <DashboardSidebar
        isOpenSidebar={open}
        onCloseSidebar={() => setOpen(false)}
      />
      <MainStyle>
        <Outlet />
      </MainStyle>
      <CoachBottomNav onMore={() => setOpen(true)} />
    </RootStyle>
  );
}
